import {emptyValidator, formValidator} from "../../validators";

const alertNotificationValidationStatus = {
    nodAlertType:{
        validators: [emptyValidator()],
        name: "Alert Type",
    },
    nodStaCode:{
        validators: [emptyValidator()],
        name: "Notification Status Code",
    },
    nodDefaultId:{
        validators: [emptyValidator()],
        name: "Default Selected Type",
    },
    nodStatus:{
        validators: [emptyValidator()],
        name: "Status",
    },
    nodActive:{
        validators: [emptyValidator()],
        name: "Active",
    },
};

export const alertNotificationValidation = (alert) => {
    return formValidator(alert, alertNotificationValidationStatus);
};